export default "__VITE_ASSET__DkpTh95h__"